<template>
  <div>
    <div class="bg-black fixed top-0 right-0 w-full h-full" v-on:click="close" style="z-index:150;opacity:0.5;"></div>

    <div class="bg-white fixed top-0 right-0 h-full" style="width:320px;z-index:200;">

      <div class="bg-gray-200 border-b flex items-center justify-between p-4">
        <div class="text-base text-gray-800">
          Options for {{ client.applicants[0].name }}
        </div>

        <a href="#" 
          @click.prevent="close"
          class="outline-none text-gray-600 text-xs hover:text-gray-700">
          <svg width="20" height="20" stroke-width="2" stroke="currentColor" fill="none">
            <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
          </svg>    
        </a>
      </div>

      <div class="m-4">

        <router-link
          :to="{
            name : 'application-applicant-profile',
            params : {
              clientId   : client.id,
              applicantId: client.applicants[0].id
            }
          }"
          tag="a"
          class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-3">Go to application form</router-link>

        <a href="#" @click.prevent="viewSendClientModal()"
          class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-3">Send this client to another broker</a>

        <a href="#" @click.prevent="viewNoteModal()"
          class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-3">View notes</a>

        <template v-if="!$store.state[$store.state.view + 'Module'].broker.suspended">
          <a :href="getBackendHost + '/api/report/preview/' + client.id + '?token=' + getJwt"
            target="_blank"
            class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2">Download summary report</a>

          <a href="#"
            class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
            @click.prevent="downloadAllAsZip(client.id, client.applicants[0].name)"
            v-if="client.num_documents_received != null && client.num_documents_received > 0">Download documents as a .zip file</a>

          <template v-if="showMercuryOption">
            <router-link
              :to="{ name: 'application-mercury-confirm', params : { clientId : this.client.id }}"
              tag="a"
              class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2">Upload to Mercury</router-link>
          </template>

          <router-link
            :to="{ name: 'application-submit-broker', params : { clientId : this.client.id }}"
            tag="a"
            class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2">Re-send application to client</router-link>

          <a href="#"
            class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
            v-if="this.client.client_token_created_at != null"
            @click.prevent="toggleAccess('disable')">Disable client's access</a>

          <a href="#"
            class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
            v-if="this.client.client_token_created_at == null"
            @click.prevent="toggleAccess('enable')">Enable client's access</a>

          <a href="#" @click.prevent="showClientSourceModal()"
            class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-3">Add / edit client acquisition source</a>

          <template v-if="this.client.settled == 1 || this.client.settled == 2">
            <a href="#"
              class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
              @click.prevent="changeClientStatusLocal(0)">Move this client back to 'active'</a>
          </template>

          <template v-else>
            <div class="mt-6 text-sm text-gray-700 text-center">
              Mark this client as
            </div>

            <div class="flex flex-wrap">
              <div class="w-1/2 pr-1">
                <a href="#"
                  class="block no-underline p-3 font-semibold bg-green-500 text-white hover:bg-green-600 mt-2 text-center"
                  @click.prevent="showSettledModal()">Settled</a>
              </div>

              <div class="w-1/2 pl-1">
                <a href="#"
                  class="block no-underline p-3 font-semibold bg-gray-600 text-white hover:bg-gray-700 mt-2 text-center"
                  @click.prevent="changeClientStatusLocal(2)">Pending</a>
              </div>
            </div>
          </template>

        </template>

        <div class="absolute w-full" style="width:288px;bottom:10px;">
          <a href="#"
            class="block no-underline p-3 font-semibold bg-red-500 text-white hover:bg-red-600"
            @click.prevent="deleteClient">Delete this client</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus'

  export default {

    props : {
      client : {
        type    : Object,
        required: true
      }
    },

    methods : {
      close() {
        EventBus.$emit('close-client-actions')
      },

      showSettledModal() {
        this.$modal.show('settled-modal', {
          client : this.client
        })

        this.close()
      },

      toggleAccess(enableOrDisable) {
        EventBus.$emit('toggle-access', {
          clientId       : this.client.id,
          enableOrDisable: enableOrDisable
        })
      },

      viewSendClientModal() {
        // if(this.$store.state[this.$store.state.view + 'Module'].broker.suspended) {
        //   this.showSuspendedModal()
        // }

        // else {
          this.$modal.show('send-client-modal', {
            client : this.client
          })
        // }

        this.close()
      },

      viewNoteModal() {
        this.$modal.show('notepad-modal', {
          client : this.client
        })

        this.close()
      },

      showClientSourceModal() {
        this.$modal.show('client-source-modal', {
          client: this.client,
        })

        this.close()
      },

      changeClientStatusLocal(status) {
        this.close()
        this.showLoader("Updating...")
        this.changeClientStatus(this.client.id, status, (res) => {
          EventBus.$emit('fetch-clients')
          EventBus.$emit('get-num-clients-by-type')
          EventBus.$emit('notification-event', {
            type   : 'success',
            message: 'Client updated successfully.'
          })
        })
      },

      deleteClient() {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete client - <b class='text-red-500'>" + this.client.applicants[0].name + "</b>?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                clientId : this.client.id
              }, 'client/delete', () => {
                this.$modal.hide('confirm-modal')
                this.close()
                EventBus.$emit('fetch-clients')
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Client deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    },
  }
</script>